import { React, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import '../../styles/TableForUipps.css';
import Table from '../Table/Table';
import Modal from '../Modal/Modal';
import CustomButton from '../CustomElements/CustomButton';
import AddUipps from './AddUipps';
import Uipps from './Uipps';
import { defaultCellRender } from '../../utils/formatValueForHTML';
import { useRole } from '../../customHook/useRole';
import { useSocketListener } from '../../customHook/useSocketListener';
import { useSocketEmitOnUnmount } from '../../customHook/useSocketEmitOnUnmount';
import { emitGetCoordsStart, emitGetCoordsStop, listenUippsCoords } from '../../redux/actions/uipps.action';
import CopyButton from '../CustomElements/CopyButton';
import { copyCoordsToClipboard } from '../../utils/copyCoordsToClipboard';

function TableForUipps({ formData, bottomBoundaryRef, t }) {
  const dispatch = useDispatch();
  // Получение данных устройств из Redux store
  const uipps = useSelector((state) => state.uipps);
  const [uippsId, setUippsId] = useState();

  const isMaster = useRole('master');

  // Состояния для отображения компонентов и модального окна
  const [isOpen, setIsOpen] = useState(false);
  const [newUippsModal, setNewUippsModal] = useState(false);
  const [openUippsModal, setOpenUippsModal] = useState(false);

  // Открыть модалку для добавления нового устройства
  const addNewUipps = () => {
    setNewUippsModal(true);
    setIsOpen(true);
  };

  // Открыть модалку для просмотра устройства
  const openUipps = (id) => {
    setUippsId(id);
    setOpenUippsModal(true);
    setIsOpen(true);
  };

  // Закрыть модальное окно
  const closeModal = () => {
    setIsOpen(false);
    setNewUippsModal(false);
    setOpenUippsModal(false);
  };

  const columns = useMemo(
    () => [
      {
        Header: t?.uippsId || 'ID УИППС',
        accessor: 'id',
        Cell: ({ cell: { value } }) => (
          <div className="table-for-cell-id">
            <span className="cell-id-icon"></span>
            <span className="cell-id-value">{value}</span>
          </div>
        ),
      },

      {
        Header: t?.road || 'Дорога',
        accessor: 'road',
        Cell: ({ value }) => defaultCellRender(value),
      },
      {
        Header: t?.directorate || 'Дирекция',
        accessor: 'directorate',
        Cell: ({ value }) => defaultCellRender(value),
      },
      {
        Header: t?.department || 'Подразделение',
        accessor: 'department',
        Cell: ({ value }) => defaultCellRender(value),
      },
      {
        Header: t?.trainType || 'Тип ПС',
        accessor: 'trainType',
        Cell: ({ value }) => defaultCellRender(value),
      },
      {
        Header: t?.trainNumber || '№ ПС',
        accessor: 'trainNumber',
        Cell: ({ value }) => <div className="number-cell">{defaultCellRender(value)}</div>,
      },
      {
        Header: t?.responsible || 'Ответственный',
        accessor: 'responsible',
        Cell: ({ value }) => defaultCellRender(value),
      },
      {
        Header: t?.inWork || 'В работе',
        accessor: 'online',
        disableSorting: true, // Флаг для отключения сортировки
        tooltipText: t?.tooltipStatus || 'Сортировка  не активна, Вы можете выполнить фильтрацию по статусу.',
        Cell: ({ cell: { value } }) => (
          <div className={`status-icon ${value ? 'status-online' : 'status-offline'}`}></div>
        ),
      },

      {
        Header: t?.copyCoords,
        accessor: 'copyCoords',
        disableSorting: true,
        Cell: ({ row: { original } }) => <CopyButton onCopy={() => copyCoordsToClipboard(original)} />,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [uipps]
  );

  // старт прослушивания сокета
  useSocketListener([listenUippsCoords]);
  //прекращение прослушивания координат
  useSocketEmitOnUnmount([emitGetCoordsStop]);

  useEffect(() => {
    //отправляем событие чтобы сервер начал слать маркеры
    dispatch(emitGetCoordsStart({ isBounds: false }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="table-for-devices_or_uipps_container">
      <Table
        data={uipps}
        columns={columns}
        open={openUipps}
        showGlobalSearch={false}
        bottomBoundaryRef={bottomBoundaryRef}
        arrLength={uipps.length}
        disableInternalSorting
      />

      <div className={`table-for-uipps_btn-container ${isMaster ? 'padding-10' : ''}`}>
        {!isMaster && <CustomButton text={t?.addNewUipps || '+ Добавить новый УИППС'} onClick={addNewUipps} />}
      </div>
      {/* containerSelector={'.table-for-devices_or_uipps_container'} */}
      <Modal
        isOpen={isOpen}
        onClose={closeModal}
        containerSelector={openUippsModal ? '.uipps' : '.table-for-devices_or_uipps_container'}
        minusSize={openUippsModal ? '--sadr-font-size-40' : 0}
      >
        {/* Компонент для добавления нового устройства */}
        {newUippsModal && <AddUipps closeModal={closeModal} />}
        {/* Компонент для просмотра устройства */}
        {openUippsModal && (
          <Uipps closeModal={closeModal} uippsId={uippsId} setCurrentUipps={setUippsId} formData={formData} t={t} />
        )}
      </Modal>
    </div>
  );
}

export default TableForUipps;
